/* eslint-disable */
// @ts-nocheck
//@ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Pangostack
 * SaaS Deployment Tool
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpsertTeamUserDto
 */
export interface UpsertTeamUserDto {
    /**
     * The ID or email address of the user.
     * @type {string}
     * @memberof UpsertTeamUserDto
     */
    userIdOrEmail: string;
    /**
     * The role of the user within the team.
     * @type {string}
     * @memberof UpsertTeamUserDto
     */
    role: string;
}

/**
 * Check if a given object implements the UpsertTeamUserDto interface.
 */
export function instanceOfUpsertTeamUserDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "userIdOrEmail" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function UpsertTeamUserDtoFromJSON(json: any): UpsertTeamUserDto {
    return UpsertTeamUserDtoFromJSONTyped(json, false);
}

export function UpsertTeamUserDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpsertTeamUserDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'userIdOrEmail': json['userIdOrEmail'],
        'role': json['role'],
    };
}

export function UpsertTeamUserDtoToJSON(value?: UpsertTeamUserDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'userIdOrEmail': value.userIdOrEmail,
        'role': value.role,
    };
}

